import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import * as d3 from 'd3';

import '../styles/CourseDetailWrapper.css';

class SectionDataVisualizer extends Component {
    constructor(props) {
        super(props);
        this._updateDimensions = this._updateDimensions.bind(this);
        this.state = { data: props.data, selected: props.selected, visualized: false };
    }

    _getDimension() {
        let margin = { top: 50, bottom: 40, left: 60, right: 60 };
        let w = 620;
        let h = 320;

        let mq = window.matchMedia("(max-width: 1300px)");
        if (mq.matches) {
            mq = window.matchMedia("(max-width: 850px)");
            if (mq.matches) {
                mq = window.matchMedia("(max-width: 430px)");
                if (mq.matches) {
                    mq = window.matchMedia("(max-width: 320px)");
                    if (mq.matches) {
                        w = 220;
                        h = 200;
                        margin.top = 30;
                    } else {
                        w = 280;
                        h = 240;
                        margin.top = 40;
                    }
                    

                    

                } else {
                    w = 400;
                    h = 300;
                }
                margin.left = 42;
                margin.right = 42;

            } else {
                w = 520;
            }
        }

        return { 'w': w, 'h': h, 'margin': margin };
    }

    _visualize() {
        if (this.state.visualized) return;
        // console.log(this.state.data);
        d3.select(ReactDOM.findDOMNode(this)).selectAll('svg').remove();

        let data = this.state.data;
        let { w, h, margin } = this._getDimension();



        let svg = d3.select(ReactDOM.findDOMNode(this)).append('svg').attr('width', w).attr('height', h)
            .append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        w -= margin.right + margin.left;
        h -= margin.top + margin.bottom;

        let maxY = (window.matchMedia('(max-width: 850px)').matches) ? parseInt(d3.max(data.map(d => d.freq)) / 5 + 1) * 5 : 100;

        let x = d3.scaleBand().domain(data.map(d => d.letter)).range([0, w]).paddingInner(0.2);
        let y = d3.scaleLinear().domain([0, maxY]).range([h, 0]).nice();

        let bars =  svg.append('g').classed('bar-holder', true);
        let barWidth = x.bandwidth();

        let barDesc = (window.matchMedia('(max-width: 1300px)').matches) ? ((d) => d.count) : ((d) => d.count + ' (' + d.freq.toFixed(1) + '%)');

        let yAxisText = (window.matchMedia('(max-width: 850px)').matches) ? '' : '%';

        let fontSize = (window.matchMedia('(max-width: 700px)').matches) ? ((window.matchMedia('(max-width: 320px)').matches) ? 6 : 10) : 12;

        let countFontSize = (window.matchMedia('(max-width: 430px)').matches) ? '-4px' : '-8px';

        // console.log(barDesc);

        bars.selectAll('rect.bar').data(data).enter()
            .append('rect').classed('bar', true).attr('x', d => x(d.letter)).attr('width', barWidth)
            .attr('y', d => y(d.freq)).attr('height', d => h - y(d.freq));
        bars.selectAll('text').data(data).enter()
            .append('text').attr('x', d => x(d.letter)).attr('y', d => y(d.freq)).attr('height', d => h - y(d.freq))
            .attr('dx', barWidth / 2).attr('dy', countFontSize).attr('text-anchor', 'middle').attr('fill', 'black')
            .style('font-size', Math.max(fontSize - 2, 8).toString() + 'px').text(barDesc); // 10px

        let xAxis = d3.axisBottom(x).tickSizeOuter(0);
        let yAxis = (maxY === 100) ? d3.axisLeft(y) : d3.axisLeft(y).ticks(5).tickSizeOuter(0).tickFormat(d => d + '%') ;

        svg.append('g').classed('x axis', true).attr('transform', 'translate(0,' + h + ')')
            .style('font-size', '14px').call(xAxis);
        svg.append('g').classed('y axis', true).style('font-size', (maxY === 100) ? '12px' : '10px').call(yAxis);
        svg.append('text').attr('transform', 'rotate(-90)translate(-' + h / 2 + ',0)').style('text-anchor', 'middle')
            .style('font-size', (fontSize + 2).toString() + 'px').style('fill', 'black').attr('dy', '-2.5em').text(yAxisText); // 14px
        // title
        if (window.matchMedia('(min-width: 320px)').matches)
            svg.append('text').attr('x', w / 2).attr('y', 0 - margin.top / 2 + 5).attr('text-anchor', 'middle')
                .style('font-size', fontSize.toString() + 'px').text(this.state.selected); // 12px
    }

    componentWillReceiveProps(props) {
        // console.log(props.data);
        if (props.selected !== this.state.selected)
            this.setState({data: props.data, selected: props.selected});
    }

    _updateDimensions() {
        this.setState({ visualized: false });
    }

    componentDidMount() {
        window.addEventListener("resize", this._updateDimensions);
        if (!this.state.visualized) this._visualize();
    }

    componentDidUpdate() {
        this._visualize();
    }

    render() {
        return (<div id="data-placeholder"></div>);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this._updateDimensions);
    }
}

export default SectionDataVisualizer;



// WEBPACK FOOTER //
// ./src/components/SectionDataVisualizer.js